import React from 'react';
import { IconBaseProps } from 'react-icons';
import { MdMicOff } from 'react-icons/md';

const Mute: React.FC<IconBaseProps> = (props) => <MdMicOff {...props} />;

export default Mute;
